import { render, staticRenderFns } from "./EmailVerificationInit.vue?vue&type=template&id=06c66e07"
import script from "./EmailVerificationInit.vue?vue&type=script&lang=js"
export * from "./EmailVerificationInit.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationInit.vue?vue&type=style&index=0&id=06c66e07&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports